import React from 'react';
import {observer} from 'mobx-react';
import {BaseProps} from "../../../../infrastructure/models/props/base-props";
import {StandingsWidgetRecentFormGameViewModel} from "../../models/standings-widget.recent-form-game.view-model";
import {TREND_WINNER_STATUSES} from "../../../../core/consts";
import {StandingsWidgetController} from "../../standings-widget.controller";
import styles from "../../styles/standings-widget.module.scss";
import classNames from "classnames";
import {StandingWidgetCompetitorViewModel} from "../../models/standings-widget.competitor-view-model";

export class StandingsWidgetRecentFormBadgeDataLessProps extends BaseProps {
  controller: StandingsWidgetController;
  game: StandingsWidgetRecentFormGameViewModel;
  competitor: StandingWidgetCompetitorViewModel;
}

export const StandingsWidgetRecentFormBadgeDataLess = observer(({
                                                          controller,
                                                          winnerStatus,
                                                        }: StandingsWidgetRecentFormBadgeDataLessProps) => {
  const {terms} = controller;
  const {
    GAME_CENTER_H2H_WIN,
    GAME_CENTER_H2H_DRAW,
    GAME_CENTER_H2H_LOSE,
  } = terms;

  const statusTexts = {
    [TREND_WINNER_STATUSES.win]: GAME_CENTER_H2H_WIN,
    [TREND_WINNER_STATUSES.draw]: GAME_CENTER_H2H_DRAW,
    [TREND_WINNER_STATUSES.lose]: GAME_CENTER_H2H_LOSE
  }

  const colors = {
    [TREND_WINNER_STATUSES.win]: styles.table_row_badge_win,
    [TREND_WINNER_STATUSES.draw]: styles.table_row_badge_draw,
    [TREND_WINNER_STATUSES.lose]: styles.table_row_badge_lose
  }

  const text = statusTexts[winnerStatus];
  const colorClassName = colors[winnerStatus];

  const linkProps = {
      className: classNames(styles.table_row_badge, colorClassName, styles.table_row_badge_data_less),
  }

  return (
    <div {...linkProps}>
        {text}
    </div>
  )
});
